import Layout from "@/components/Layout/index.ts";
import RootErrorBoundary from "@/components/RootErrorBoundary/index.ts";
import HomePage from "@/pages/HomePage/index.ts";
import {createBrowserRouter, type RouteObject} from "react-router-dom";
import SearchStatementPage from "@/pages/SearchStatementPage";

const pathRoutes: RouteObject[] = [
    {
        path: "/",
        element: <HomePage />,
    },
    {
        path: "/search-statements",
        element: <SearchStatementPage />,
    },
];

const rootRoute: RouteObject = {
    path: "/",
    element: <Layout />,
    errorElement: <RootErrorBoundary />,
    children: pathRoutes,
};

export const router = createBrowserRouter([rootRoute]);

if (import.meta.hot) {
    import.meta.hot.dispose(() => router.dispose());
}
